import { RoomSelectionOptionsType } from './types';

export const ROOM_SELECTION_OPTIONS: RoomSelectionOptionsType = [
  { id: 'hotel_suit', title: '🏩 Hotel suit' },
  { id: 'bdsm_dungeon', title: '🌶️ BDSM Dungeon' },
  { id: 'private_strip_club_room', title: '❤️‍🔥 Private strip club room' },
  { id: 'shower', title: '💦 Shower' },
  { id: 'naughty_classroom', title: '📚 Naughty classroom' },
  { id: 'massage_room', title: '🕯️ Massage Room' },
  { id: 'pool_at_night', title: '🌃 Pool at night' },
];
